var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultEmptyImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F2BA4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.417 11.75H19.583a7.833 7.833 0 00-7.833 7.833v54.834a7.833 7.833 0 007.833 7.833h54.834a7.833 7.833 0 007.833-7.833V19.583a7.833 7.833 0 00-7.833-7.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.291 39.167a5.875 5.875 0 100-11.75 5.875 5.875 0 000 11.75zM82.25 58.75L62.668 39.167 19.584 82.25"
  }))));
}
export default SvgDefaultEmptyImage;